module.exports = "/static/fonts/OpenSans-ExtraBold.woff";